/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PresentAddressSelected model module.
 * @module model/PresentAddressSelected
 * @version 1.0.0
 */
class PresentAddressSelected {
    /**
     * Constructs a new <code>PresentAddressSelected</code>.
     * @alias module:model/PresentAddressSelected
     */
    constructor() { 
        
        PresentAddressSelected.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PresentAddressSelected</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PresentAddressSelected} obj Optional instance to populate.
     * @return {module:model/PresentAddressSelected} The populated <code>PresentAddressSelected</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PresentAddressSelected();

            if (data.hasOwnProperty('present_confirmed')) {
                obj['present_confirmed'] = ApiClient.convertToType(data['present_confirmed'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} present_confirmed
 */
PresentAddressSelected.prototype['present_confirmed'] = undefined;






export default PresentAddressSelected;

